module.exports = __webpack_public_path__ + "img/Sleeves-Front-Gd-Hc-Ib.b1171406.png";